import type { StripeGetCustomersResponse } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useStripeCustomers(
  searchTerm?: string,
  options?: CustomUseQueryOptions<StripeGetCustomersResponse>,
) {
  return useQuery(
    queryKeys.stripeCustomers(searchTerm),
    () => {
      const api = getPrivateApi();

      return api.stripeGetCustomers({ searchTerm });
    },
    {
      ...options,
    },
  );
}
